export default {
  menu: 'Preference Management',
  title: {
    list: 'Survey List',
    edit: 'Edit Survey',
    survey: {
      employee: 'Employee Survey',
      candidate: 'Candidate Survey'
    }
  },
  label: {
    name: 'Target User',
    question: {
      cn: 'Chinese Question',
      en: 'English Question'
    },
    answerType: 'Answer Type',
    optionType: 'Question Option Type',
    optionTypeTip: 'Please note, some questions as indicated, will impact the automated job alert system. The job alert system allows candidates to be automatically notified when a new job that matches their preferneces is created. ',
    customOptions: {
      cn: 'Chinese Language Custom Response Options',
      en: 'English Language Custom Response Options'
    },
    disabled: ' (Disabled) '
  },
  surveyType: {
    employee: 'Employee Survey',
    candidate: 'Candidate Survey'
  },
  answerType: {
    single: 'Single Choice',
    multiple: 'Multiple Choice'
  },
  optionType: {
    custom: 'Custom',
    tag: 'Job Tag',
    city: 'Job City (Impacts Job Alert) ',
    role_type: 'Role Type (Impacts Job Alert) ',
    job_type: 'Job Type (Impacts Job Alert) ',
    suffix: ' (Impacts Job Alert) '
  },
  upload: {
    pc: {
      tip: 'Add PC Header Image',
      subTip: 'Recommended Size is: 1100*380 ( < 5MB )'
    },
    mobile: {
      tip: 'Add Mobile Header Image',
      subTip: 'Recommended Size is: 750*450 ( < 5MB )'
    }
  },
  btn: {
    addQuestion: {
      select: 'Add Dropdown Question',
      text: 'Add Text Field Question'
    },
    editQuestion: {
      select: 'Edit Dropdown Question',
      text: 'Edit Text Field Question'
    }
  },
  message: {
    imageRequired: 'Please add PC and mobile images',
    questionRequired: 'Please add at least one question',
    questionNameRequired: 'This field cannot be empty.',
    questionTypeRequired: 'Please select the answer type',
    optionTypeRequired: 'Please select the option type',
    customOptionsRequired: 'This field cannot be empty',
    customOptionsNeedSameLine: 'The number of custom options in both the English and Chinese sections must be the same',
    wrongImageType: 'Please upload an image file.',
    wrongImageSize: 'Please upload an image file no larger than {size}MB.',
    uploadError: 'Upload failed, please try again later'
  }
}
